import React from "react";

import useScrollToTop from "../../../hooks/useScrollToTop";
import Reveal from "../../../components/Reveal/Reveal";
import ScrollIndicator from "../../../components/ScrollIndicator/ScrollIndicator";

import Footer from "../HomePage/Footer";
import Team from "./Team";
import ClubHistory from "./ClubHistory";
import DojoContacts from "./DojoContacts";

import "../HomePage/Home.css";

function ClubPage() {
  useScrollToTop();

  return (
    <div className="min-h-screen overflow-hidden bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-white">
      <main className="relative">
        <section className="relative overflow-hidden bg-slate-950 px-4 pb-16 pt-36 text-white sm:px-6 lg:px-8 lg:pb-20 lg:pt-40">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(242,113,49,0.30),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(59,130,246,0.22),transparent_32%)]" />
          <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.08)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.08)_1px,transparent_1px)] bg-[size:44px_44px] opacity-20" />

          <div className="relative mx-auto max-w-7xl">
            <Reveal className="max-w-3xl">
              <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-white/70 backdrop-blur-xl">
                Le club
              </div>

              <h1 className="mt-6 font-barlow text-5xl font-bold leading-tight tracking-tight text-white sm:text-6xl lg:text-7xl">
                Découvrez le club,
                <br />
                son équipe et son dojo
              </h1>

              <p className="mt-6 max-w-2xl text-base leading-8 text-white/75 sm:text-lg">
                Retrouvez les personnes qui font vivre l’association, l’histoire
                du club et les informations pratiques pour nous rencontrer.
              </p>
            </Reveal>
          </div>
        </section>

        <Team />
        <ClubHistory />
        <DojoContacts />

        <Footer />
        <ScrollIndicator />
      </main>
    </div>
  );
}

export default ClubPage;